// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n  .ImagePopup__container__EP5Zj img {\n    cursor: pointer;\n    max-width: 100%;\n    max-height: 300px;\n  }\n", "",{"version":3,"sources":["webpack://./components/Flowciraptor/ImagePopup/style.css"],"names":[],"mappings":";EACE;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB","sourcesContent":[".container {\n  & img {\n    cursor: pointer;\n    max-width: 100%;\n    max-height: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ImagePopup__container__EP5Zj"
};
export default ___CSS_LOADER_EXPORT___;
